<template>
  <div class="dashboard">

      <!-- INIT Min boxes-->
      <b-row>
        <b-col><box-card v-bind:title="titleAlert" v-bind:class="'md-3'"></box-card></b-col>
        <b-col><box-card v-bind:title="titleWarning" v-bind:class="'md-3'"></box-card></b-col>
        <b-col><box-card v-bind:title="titleSomething" v-bind:class="'md-3'"></box-card></b-col>
        <b-col><box-card v-bind:title="titleSomething" v-bind:class="'md-3'"></box-card></b-col>
      </b-row>
      <!-- END Min boxes-->


      <!-- SPACER-->
      <spacer-card></spacer-card>
      <!-- SPACER-->

      <!-- INIT Resume Panel-->
      <b-row>
        <b-col><box-card v-bind:title="titleResume" v-bind:class="''"></box-card></b-col>
      </b-row>
      <!-- END Resume Panel-->



  </div>
</template>

<script>
import Boxcard from '@/components/card/Boxcard';
import Spacer from '@/components/card/Spacer';

export default {
    data () {
        return {
            titleAlert: 'Usuarios',
            titleWarning: 'Endpoints',
            titleSomething: 'Gateways',
            titleResume: 'Memoria'

        }
    },
    components: {
      'box-card': Boxcard,
      'spacer-card': Spacer
    }
}
</script>
